import React from 'react';
import PropTypes from 'prop-types';
import styles from './ModalParts.module.scss';

/* ────────────────────────────────────────────────────────────
 * ModalGrid — responsive form grid for modal bodies.
 *
 * Two columns by default, collapses to a single column at
 * $bp-md. Pass `columns={1}` for a single-column form, or
 * `columns={3}` for dashboards that genuinely need three.
 *
 *   <ModalGrid>
 *     <ModalField label="Name" required>…</ModalField>
 *     <ModalField label="Email">…</ModalField>
 *     <ModalField label="Description" fullWidth>…</ModalField>
 *   </ModalGrid>
 *
 * Children that need to span every column use the `fullWidth`
 * prop on ModalField, or the `.modal-grid-full` class on a
 * custom child.
 * ──────────────────────────────────────────────────────────── */

const COLUMN_MAP = {
  1: styles.gridCols1,
  2: styles.gridCols2,
  3: styles.gridCols3,
};

const ModalGrid = ({ columns, children, className }) => (
  <div
    className={[
      styles.grid,
      COLUMN_MAP[columns] || COLUMN_MAP[2],
      className || '',
    ]
      .filter(Boolean)
      .join(' ')}
  >
    {children}
  </div>
);

ModalGrid.propTypes = {
  columns: PropTypes.oneOf([1, 2, 3]),
  children: PropTypes.node,
  className: PropTypes.string,
};

ModalGrid.defaultProps = {
  columns: 2,
  children: null,
  className: '',
};

export default ModalGrid;
